var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoBlockedCountries = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_43792",
    "data-name": "Group 43792",
    transform: "translate(-11 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "japan_1_",
    "data-name": "japan (1)",
    transform: "translate(-60.647 2)",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48570",
    "data-name": "Path 48570",
    d: "M168.54,90a3.225,3.225,0,1,0,3.224,3.162A3.2,3.2,0,0,0,168.54,90Zm0,4.743a1.613,1.613,0,1,1,1.612-1.581A1.6,1.6,0,0,1,168.54,94.743Z",
    transform: "translate(-87.27 -86.822)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48571",
    "data-name": "Path 48571",
    d: "M240.842,165a.527.527,0,1,0,.527.527A.528.528,0,0,0,240.842,165Z",
    transform: "translate(-159.572 -159.182)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48572",
    "data-name": "Path 48572",
    d: "M81.271,0c-3.419,0-6.52,1.982-6.622,6.345s4.847,9.387,6.212,11.109l.41.546.41-.546c1.387-1.752,6.067-6.745,5.965-11.109S84.69,0,81.271,0Zm0,10.575a4.187,4.187,0,0,1-4.134-4.23,4.134,4.134,0,1,1,8.268,0A4.187,4.187,0,0,1,81.271,10.575Z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoBlockedCountries);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_blocked_countries.69c680e005492880bf047eae6adf62e5.svg";